import { Skeleton } from "@volca/ui/components/ui/skeleton";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";

interface PaymentsSummaryInfoProps {
  value?: React.ReactNode;
  label?: React.ReactNode;
  date?: React.ReactNode;
  show?: boolean;
  isLoading?: boolean;
}

export const PaymentsSummaryInfo = ({
  value,
  label,
  date,
  isLoading,
  show = true,
}: PaymentsSummaryInfoProps) => {
  if (isLoading) {
    return (
      <Stack align="start" className="p-3 pr-8 pl-4" gap={0}>
        <Skeleton className="h-6 w-30" />
        <Skeleton className="mt-2 h-4 w-25" />
      </Stack>
    );
  }

  if (!show) {
    return null;
  }

  return (
    <Stack align="start" className="p-3 pr-8 pl-4" gap={0}>
      <Stack direction="row" gap={4} align="center" className="h-[32px]">
        <Text variant="title">{value}</Text>
        <Text tone="muted">{date}</Text>
      </Stack>
      <Text variant="label" tone="muted">
        {label}
      </Text>
    </Stack>
  );
};
